<template>
</template>
<script>
import Spinner from 'vue-simple-spinner'
import { FileUploadService } from 'v-file-upload'
export default {
  name: "core-input",
  components: {

      "vue-simple-spinner":Spinner
  },
                 props: {
                     isRequired: {
                         type: Boolean,
                         default: !1
                     },
                     processIn: {
                         type: Boolean,
                         default: !1
                     },
                     isfile: {
                         type: Boolean,
                         default: !1
                     },
                     minLength: {
                         type: Number,
                         default: 0
                     },
                     Typess: {
                         type: String,
                         default: "email"
                     },
                     regex: {
                         type: String,
                         default: null
                     },
                     colorMessage: {
                         type: String,
                         default: "clear"
                     },
                     content: {
                         type: Object,
                         default: function() {}
                     }
                 },
                 data: function() {
                     return {
                         isValid: !1
                     }
                 },
                 created: function() {
                     this._value = ""
                 },
                 mounted: function() {
                     this.$emit("on:mounted", this.$el)
                 },
                 methods: {
                     onFocusIn: function(t) {
                         this.$el.classList.add("is-active")
                     },
                     onFocusOut: function(t) {

                         this._value = t.target.value,
                         this.$el.classList.remove("is-active");
                         if(this.isfile)
                         {
                           this.isRequired && 0 === this._value.length ? this.onError() : this.onSuccess()
                         }
                         else
                         {
                         "text" === this.Typess&&(this.isRequired && 0 === this._value.length ? this.onError() : this.onSuccess()),
                         "email" === this.Typess && this.checkEmail(), this._value.length > 0 && null !== this.regex && this.checkRegex()
                         }
                     },
                     checkRegex: function() {
                         new RegExp(this.regex, "g").test(this._value) ? this.onSuccess() : this.onError()
                     },
                     checkEmail: function() {
                         /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(this._value) ? this.onSuccess() : this.onError()
                     },
                     onSuccess: function() {
                         this.isValid = !0,
                          this.$el.classList.add("is-success"),
                         this.$el.classList.remove("is-error"),
                         this.$emit("on:success")
                     },
                     onError: function() {
                         this.isValid = !1,
                         this.$el.classList.remove("is-success"),
                         this.$el.classList.add("is-error"),
                          this.$emit("on:error")
                     },
                     handleFileUpload()
                     {
                        const customuploadtext=this.$el.querySelector("#Custom_text__upload__Careers");
                        const FileCvValue=this.$el.querySelector("#fileCV").value;
                        if(this.$el.querySelector("#fileCV").value)
                        {
                             customuploadtext.innerHTML=FileCvValue;
                        }
                         else
                         {
                             customuploadtext.innerHTML=this.content.Carrer_placeholder;
                           }
                     }
                 }
}
</script>
<style  scoped>
</style>
